import { Container } from 'react-bootstrap'
import { toDate } from '@ztechapps/common.utils'
import { AppVersion } from '@ztechapps/webui.page'

export const Footer = () => {
  return (
    <footer className="footer">
      <Container fluid>
        <div className="d-flex justify-content-between align-items-center">
          <span>&copy; {toDate().year()} TotalMilk</span>
          <AppVersion />
        </div>
      </Container>
    </footer>
  )
}
